import React from 'react';
import { useAuth } from '../../hooks/common/useAuth';
import { PERMISSION_SUBJECTS } from '../../constants/service/common/userPermissions';
import { FeatureFlagWorkspace } from '../../views/featureFlag/components/FeatureFlagWorkspace';

export const FeatureFlagContainer = (): React.JSX.Element => {
  const { can } = useAuth();
  return <FeatureFlagWorkspace canUpdate={can('update', PERMISSION_SUBJECTS.FEATURE_FLAG)} />;
};
